// Cross-browser fullscreen helpers.
//
// iOS Safari has no Fullscreen API on ordinary elements (only on <video> via
// webkitEnterFullscreen), so requestFullscreen is either missing or rejects.
// That means no `fullscreenchange` event ever fires, and any UI that clears its
// "expanded" state only from that event gets stuck open — the "Back to Normal"
// button does nothing. Callers must therefore drive the overlay from their own
// state and treat the browser fullscreen as best-effort on top of it.

export function fullscreenElement() {
  return document.fullscreenElement
      || document.webkitFullscreenElement
      || document.msFullscreenElement
      || null;
}

export function requestFullscreen(el = document.documentElement) {
  const fn = el.requestFullscreen || el.webkitRequestFullscreen || el.msRequestFullscreen;
  if (!fn) return Promise.resolve();
  try { return Promise.resolve(fn.call(el)).catch(() => {}); }
  catch { return Promise.resolve(); }
}

export function exitFullscreen() {
  if (!fullscreenElement()) return Promise.resolve();
  const fn = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen;
  if (!fn) return Promise.resolve();
  try { return Promise.resolve(fn.call(document)).catch(() => {}); }
  catch { return Promise.resolve(); }
}

// Calls `cb` when the browser leaves fullscreen (Esc, back gesture, system UI).
// Returns an unsubscribe function.
export function onFullscreenExit(cb) {
  const handler = () => { if (!fullscreenElement()) cb(); };
  const events = ['fullscreenchange', 'webkitfullscreenchange', 'MSFullscreenChange'];
  events.forEach(e => document.addEventListener(e, handler));
  return () => events.forEach(e => document.removeEventListener(e, handler));
}
